import React, { useState, useEffect,useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { toast } from "react-toastify";
import Loader from "../../components/common/Loader.js";
import { createEntity, fetch2factor } from "../../apis/apiService.js";
import {  useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { useDispatch } from "react-redux";
import { setloginUserName } from "../../selectSlice.js";
import { IoClose } from "react-icons/io5"; // React Icon

function TwoFactorScan({ token, onSuccess, isActive, onClose, setIsAuthenticated }) {
  const [loading, setLoading] = useState(false);
  const [qrUrl, setQrUrl] = useState("");
  const [account, setAccount] = useState("");
  const [key, setKey] = useState("");
  const [step, setStep] = useState(1); // Step 1 = QR, Step 2 = OTP input
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [otpError, setOtpError] = useState("");
  const inputRefs = useRef([]);
   const [remember, setRemember] = useState(false);
   const [localToken, setLocalToken] = useState(token || localStorage.getItem("access_token") || null);
  //  console.log("localToken",localToken);
   

   const dispatch = useDispatch();
const navigate =useNavigate()

// console.log("token for 2fa",token);

  // ✅ Fetch QR only when isActive === false

  // console.log("token",token);

   useEffect(() => {
    // Focus the first OTP box on mount
    inputRefs.current[0]?.focus();
  }, []);

  useEffect(() => {
  if (step === 2) {
    setTimeout(() => {
      inputRefs.current[0]?.focus();
    }, 10);
  }
}, [step]);


  useEffect(() => {
  // If token is not passed, try from localStorage
  if (!token) {
    const storedToken = localStorage.getItem("access_token");
    if (storedToken) {
      setLocalToken(storedToken); // use a local state to hold it
    }
  }
}, [token]);

  
  const setup2FA = async () => {
    // console.log("two code",isActive);
    
    setLoading(true);
    try {
      const response = await fetch2factor("setup-2fa", localToken);
      // console.log(response, "2FA response");

      if (response?.status && response?.data?.qr_code_url) {
        setQrUrl(response.data.qr_code_url);

        const url = new URL(response.data.qr_code_url);
        const label = decodeURIComponent(url.pathname.split("/")[1]);
        const params = new URLSearchParams(url.search);
        const secret = params.get("secret");

        setAccount(label);
        setKey(secret);
      } else {
        toast.error("Failed to initiate 2FA setup.");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Only call setup2FA() if isActive === false
  useEffect(() => {
    if (isActive === false) {
      setup2FA();
    }
  }, [isActive]);

  const handleNext = () => {
    setStep(2);
  };

  const handleBack = async () => {
    setStep(1);
    setOtp(["", "", "", "", "", ""])
  };


const handleOtpChange = (e, index) => {
  const value = e.target.value.replace(/[^0-9]/g, ""); // only digits
  if (value.length > 1) return;

  const newOtp = [...otp];
  newOtp[index] = value;
  setOtp(newOtp);

  // Move to next box if filled
  if (value && index < otp.length - 1) {
    const nextInput = inputRefs.current[index + 1];
    nextInput.focus();
    // Move caret to end
    nextInput.setSelectionRange(nextInput.value.length, nextInput.value.length);
  }
};

const handleKeyDown = (e, index) => {
  if (e.key === "Backspace") {
    if (!otp[index] && index > 0) {
      const prevInput = inputRefs.current[index - 1];
      prevInput.focus();
      // Move caret to the end of the previous box
      prevInput.setSelectionRange(prevInput.value.length, prevInput.value.length);
    }
  }

  if (e.key === "ArrowLeft" && index > 0) {
    const prevInput = inputRefs.current[index - 1];
    prevInput.focus();
    // Caret should be after the number
    prevInput.setSelectionRange(prevInput.value.length, prevInput.value.length);
    e.preventDefault(); // prevent default browser caret behavior
  }

  if (e.key === "ArrowRight" && index < otp.length - 1) {
    const nextInput = inputRefs.current[index + 1];
    nextInput.focus();
    // Caret should be after the number
    nextInput.setSelectionRange(nextInput.value.length, nextInput.value.length);
    e.preventDefault();
  }

  if (e.key === "Enter") {
    handleSubmitOtp(otp.join(""));
  }
};


  const handleSubmitOtp = async () => {
      const otpValue =  otp.join("");
    if (!otpValue || otpValue.length < 6) {
      setOtpError("Please enter a valid 6-digit OTP.");
      return;
    }

    setLoading(true);
    setOtpError("");

    try {
      const payload = {
        one_time_password: otpValue,
        remember: remember,
      };

      const response = await createEntity("verify-2fa", payload,token);
      // console.log("response TOken from the OTP",response.token);
      
    const { user, require_2fa, step } = response;
      if (response?.status) {

           if (user) {
                  localStorage.setItem("access_token", "secure-cookie-auth");
        
                  dispatch(setloginUserName(user));
                }
        toast.success("2FA has been successfully enabled!");
        if (response.user.is_two_fa_verified){
          if (setIsAuthenticated) setIsAuthenticated(true);
          window.location.href = "/dashboard";
        }
      } else {
        toast.error("Invalid OTP. Please try again.");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

return (
  <div className="p-3">
    {loading ? (
      <Loader />
    ) : (
      <div
        className="card p-4 border-0 position-relative"
        style={{
          backgroundColor: "var(--cell-bg-color, white)",
          color: "var(--text-color, black)",
        }}
      >
        {/* X Close Icon */}
      

        {/* Step 1 */}
     
          <>
            <h5 className="mb-3">
              2-Factor authentication is currently{" "}
              <span
                className="badge"
                style={{ backgroundColor: "#fbdb53", color: "#000" }}
              >
                disabled
              </span>
              . To enable:
            </h5>

            <ol>
              <li className="mb-3">
                Open your OTP app and <b>scan the following QR-code</b>:
                <div className="text-center my-3 pe-5  d-flex align-items-center justify-content-center" style={{padding:"40px",}}>
                  {qrUrl ? (
                    <div className=" w-25 h-75 py-4 rounded" style={{backgroundColor:"white"}}>
                    <QRCodeCanvas value={qrUrl} size={180} />
                    </div>
                  ) : (
                    <p className="text-danger">QR code not available</p>
                  )}
                </div>
              </li>

              <li className="mb-3">
                <b>Can’t scan the code?</b>
                <p className="mt-2">
                  To add the entry manually, provide the following details to
                  your OTP application:
                </p>
                <p>
                  <b>Account:</b> {account || "N/A"} <br />
                  <b>Key:</b> {key || "N/A"}
                </p>
              </li>
            <li className="mb-3">
  <b className="mb-3">
    NOTE : There are several 2-Factor applications available that you can use for this that works on various platforms:
  </b>
  <ol>
    <li className="my-3">
      <b>Authy</b> – Works on many platforms and can synch between platforms (
      <a href="https://authy.com/" target="_blank" rel="noopener noreferrer">
        https://authy.com/
      </a>
      )
    </li>
    <li className="my-3">
       <b>Google Authenticator</b>
      <ol type="a">
        <li>
          Android:<br />
          <a
            href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_US&gl=US"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_US&gl=US
          </a>
        </li>
        <li>
          iOS:<br />
          <a
            href="https://apps.apple.com/us/app/google-authenticator/id388497605"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://apps.apple.com/us/app/google-authenticator/id388497605
          </a>
        </li>
      </ol>
    </li>
    <li>
     <b>Microsoft Authenticator</b>
      <ol type="a">
        <li>
          Android:<br />
          <a
            href="https://play.google.com/store/apps/details?id=com.azure.authenticator&hl=en_US&gl=US"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://play.google.com/store/apps/details?id=com.azure.authenticator&hl=en_US&gl=US
          </a>
        </li>
        <li>
          iOS:<br />
          <a
            href="https://apps.apple.com/us/app/microsoft-authenticator/id983156458"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://apps.apple.com/us/app/microsoft-authenticator/id983156458
          </a>
        </li>
      </ol>
    </li>
  </ol>
</li>

            </ol>

            <div className="text-end">
              <button className="btn " style={{backgroundColor:"rgba(18, 183, 159, 1)",color:"white"}} onClick={handleNext}>
                Next
              </button>
            </div>
          </>
      

        {/* Step 2 */}
        {step === 2 && !loading && (
          <>
            {/* Overlay */}
            <div
              className="position-fixed top-0 start-0 w-100 h-100"
              style={{ background: "rgba(0,0,0,0.5)", zIndex: 1040 }}
              onClick={() => setStep(1)}
            />

            {/* Modal */}
            <div
              className="position-fixed top-50 start-50 translate-middle bg-white p-4 rounded"
              style={{ zIndex: 1050, width: "400px", maxWidth: "90%" }}
            >
              {/* X Close */}
              <div className="text-end mb-2">
                <IoClose
                  size={24}
                  style={{ cursor: "pointer" }}
                  onClick={handleBack}
                />
              </div>

              <h4 className="mb-2 text-center">Enable 2FA</h4>
              <p className=" mb-4 text-center" style={{color: "var(--text-color)"}}>
                Enter the 6-digit code from your authenticator app.
              </p>

              <div className="form-group mb-3 text-center">
                <div className="d-flex justify-content-center gap-2">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      className={`form-control text-center fw-bold`}
                      value={digit}
                      maxLength={1}
                      onChange={(e) => handleOtpChange(e, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      ref={(el) => (inputRefs.current[index] = el)}
                      style={{
                        width: "45px",
                        height: "50px",
                        fontSize: "20px",
                        borderRadius: "8px",
                        border: "2px solid rgba(18, 183, 159, 1)",
                        color: "rgba(18, 183, 159, 1)",
                        backgroundColor: "transparent",
                        outline: "none",
                      }}
                    />
                  ))}
                </div>
                {otpError && (
                  <div className="invalid-feedback d-block">{otpError}</div>
                )}

               <div className="mt-4 d-flex align-items-center justify-items-center ms-4 gap-1" onClick={() => setRemember(!remember)} style={{ cursor: "pointer" }} >
  <input
    type="checkbox"
    checked={remember} // ✅ use checked instead of value
    // onChange={(e) => setRemember(e.target.checked)}
    style={{ cursor: "pointer"}}
  />
  <label className="text-center" style={{ cursor: "pointer"}}>Remember me</label>
</div>

              </div>

              <div className="d-flex justify-content-between">
                <button className="btn btn-outline-secondary" onClick={handleBack}>
                  Back
                </button>
                <button className="btn" style={{backgroundColor:"rgba(18, 183, 159, 1)",color:"white"}} onClick={handleSubmitOtp}>
                  Submit
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    )}
  </div>
);

}

export default TwoFactorScan;
